// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d89fb7a1","455":"e8b5840e"}[chunkId] + ".chunk.js";
};